module.exports = __webpack_public_path__ + "images/dbe083fe7ca381e1bea71e2c30e9072b.png";